"use strict";


App.Pages.Index = class Index extends PF.Page {


    static get options() {
        return {
            rights: {
                guest: true,
            },
            panel: false,
            path: '/',
            beforeEnter: null,
            redirect: function(route, resolve, reject) {
                app.request('/auth/get-session', {}, (response) => {
                    if (response.status === 'OK') {
                        app.panelState = window.localStorage.getItem('panelState');
                        if (app.panelState === undefined || app.panelState === null) {
                            app.panelState = 'mc';
                        }
                        app.fireNotice = new App.FireNotice();
                        app.signIn(response.data);
                        resolve('/main');
                    } else {
                        app.panelState = null;
                        resolve('/sign-in');
                    }

                });
                reject();
            }
        };
    }

    static get template() {
        //language=HTML
        return `
			<div class="page navbar-fixed">
				<div class="navbar">
					<div class="navbar-bg"></div>
					<div class="navbar-inner" pf="navbarInner">
						<div class="left">
							<a href="#" class="link panel-open pf-stretch-menu-button">
								<i class="material-icons">menu</i>
							</a>
						</div>
						<div class="center">Индекс</div>
					</div>
				</div>

				<div class="page-content" pf="pageContent">

					<div id="stretchBlock" class="stretch-block">


					</div>
				</div>

			</div>
		`;
    }

    init() {
        super.init();
    }


};